import { IsPaidGuard } from './main/_guards/is-paid.guard';
import { PaymentsModule } from './main/apps/payments/payments.module';
import { Injectable, NgModule } from '@angular/core';
import { ActivatedRouteSnapshot, PreloadAllModules, Resolve, RouterModule, RouterStateSnapshot, Routes } from '@angular/router';
import { MainGuard } from './main/_guards/main.guard';
import { MainService } from './main/_services/main.service';
import { RootResolverService } from './main/_services/root-resolver.service';
@Injectable({ providedIn: 'root' })
export class AppsInternal implements Resolve<any> {
  constructor(private main: MainService) { }
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<any> {
    return new Promise((resolve) => {
      this.main.module = route.url.toString();
      resolve(this.main.module);
    });

  }
}
const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./main/pages/auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: 'portals',
    loadChildren: () => import('./main/pages/portals/portals.module').then(m => m.PortalsModule), canActivate: [MainGuard],
    resolve: { solution: AppsInternal },
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./main/apps/dashboard/dashboard.module').then(m => m.DashboardModule), canActivate: [MainGuard, IsPaidGuard],
  },
  {
    path: 'payments',
    loadChildren: () => import('./main/apps/payments/payments.module').then(m => m.PaymentsModule),
    canActivate: [MainGuard],
    resolve: { solution: RootResolverService },
  },
  {
    path: 'whatsappTemplates',
    loadChildren: () => import('./main/apps/templates/templates.module').then(m => m.TemplatesModule),
    canActivate: [MainGuard],
    resolve: { solution: RootResolverService },
  },
  {
    path: 'reset-pass',
    loadChildren: () => import('./main/pages/reset-pass/reset-pass.module').then(m => m.ResetPassModule)
  },
  {
    path: 'smsProviders',
    loadChildren: () => import('./main/pages/sms-providers/sms-providers.module').then(m => m.SmsProvidersModule)
  },
  {
    path: 'templates',
    loadChildren: () => import('./main/apps/sms-templates/sms-templates.module').then(m => m.SmsTemplatesModule),
    canActivate: [MainGuard],
    resolve: { solution: RootResolverService },
  },
  {
    path: '**',
    redirectTo: 'auth', pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule],
  providers: [IsPaidGuard]
})
export class AppRoutingModule { }
